module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"type": "object",
	"properties": {
		"filterPaneEnabled": {
			"type": "boolean",
			"messages": {
				"type": "filterPaneEnabled must be a boolean"
			}
		},
		"navContentPaneEnabled": {
			"type": "boolean",
			"messages": {
				"type": "navContentPaneEnabled must be a boolean"
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/settings.json
 ** module id = 6
 ** module chunks = 0
 **/